import React from 'react';
import { Box, Chip } from '@mui/material';

const CATEGORY_STYLES = {
  residential: { color: '#1d4ed8', bg: 'rgba(59,130,246,0.12)', dot: '#3b82f6' },
  commercial: { color: '#b45309', bg: 'rgba(245,158,11,0.12)', dot: '#f59e0b' },
  plot: { color: '#c2410c', bg: 'rgba(249,115,22,0.12)', dot: '#f97316' },
  office: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
  retail: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
  industrial: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
  warehouse: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
  other: { color: '#374151', bg: 'rgba(107,114,128,0.12)', dot: '#6b7280' },
};

function getCategoryKey(category) {
  if (!category) return 'other';
  return String(category).toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
}

function getCategoryLabel(category) {
  if (!category) return 'Other';
  const key = getCategoryKey(category);
  const labels = {
    residential: 'Residential',
    commercial: 'Commercial',
    plot: 'Plot',
    office: 'Office',
    retail: 'Retail',
    industrial: 'Industrial',
    warehouse: 'Warehouse',
  };
  return labels[key] || String(category).replace(/_/g, ' ');
}

function CategoryBadge({ category }) {
  const key = getCategoryKey(category);
  const style = CATEGORY_STYLES[key] || CATEGORY_STYLES.other;
  const label = getCategoryLabel(category);

  return (
    <Chip
      size="small"
      icon={<Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: style.dot, ml: 0.75, mr: -0.5 }} />}
      label={label}
      sx={{
        fontWeight: 600,
        fontSize: '0.75rem',
        height: 24,
        bgcolor: style.bg,
        color: style.color,
        border: 'none',
        '& .MuiChip-icon': { width: 6, height: 6, ml: 0.75 },
      }}
    />
  );
}

export default CategoryBadge;
